import dynamic from 'next/dynamic';
import { EventListProps } from './EventList.types';

export const EventList = dynamic<{ model: EventListProps }>(() => import('./EventList').then(mod => mod.EventList));
